export enum BuildingType {
  Other = 0,
  Governmental = 1,
  School = 2,
  Hospital = 3,
  SportFacility = 4,
  OfficeBuilding = 5,
  ShoppingMall = 6,
  ResidentialHouse = 7,
  Apartments = 8,
  Infrastructure = 9,
}
